import { Injectable } from '@angular/core';
import { CollectionFormField } from '../../../../../models/ts/collection-form-field.model';
import { ReadOnlyPriority } from '../enums/read-only-priority.enum';

@Injectable({
  providedIn: 'root'
})
export class CollectionFormReadOnlyService {

  public static setReadOnly(field: CollectionFormField, readOnly: boolean, readOnlyPriority: ReadOnlyPriority): CollectionFormField {
    // In case of lookup the priority is ignored
    let canOverride = CollectionFormReadOnlyService.canOverrideReadOnly(field)
    if (readOnlyPriority >= field.ReadOnlyPriority || canOverride) {
      field.IsReadOnly = readOnly;
      field.ReadOnlyPriority = canOverride ? field.ReadOnlyPriority : readOnlyPriority;
    }
    return field;
  }

  private static canOverrideReadOnly(field: CollectionFormField): boolean {
    return field.IsLookupField && field.ReadOnlyPriority == ReadOnlyPriority.Protected;
  }
}
